<template>
  <v-container class="white-container d-flex flex-column small-container" fluid>
    <v-container v-if="errorSummary !== null">
      <img
        id="verify-img"
        alt="Verify-logo"
        class="rounded-0 text-center"
        :src="require('@/assets/svg/session-expired.svg')"
      />
      <h3 class="neutral600--text">{{ $t('token-expired') }}</h3>
      <p class="neutral600--text pt-5">{{ $t('token-expired-message') }}</p>
    </v-container>
    <v-container v-if="verified">
      <img
        id="verify-img"
        alt="Verify-logo"
        class="rounded-0 text-center"
        :src="require('@/assets/svg/email-verified.svg')"
      />
      <h3 class="neutral600--text">{{ $t('account-confirmed') }}</h3>
      <p class="neutral600--text pt-5">{{ $t('account-confirmed-message') }}</p>
    </v-container>
    <v-container v-if="provider">
      <img
        id="verify-img"
        alt="Verify-logo"
        class="rounded-0 text-center"
        :src="require('@/assets/svg/provider-email-verified.svg')"
      />
      <h3 class="neutral600--text">{{ $t('provider-confirmed') }}</h3>
      <p class="neutral600--text pt-5">{{ $t('provider-confirmed-message') }}</p>
    </v-container>
  </v-container>
</template>

<script>
import util from '@/mixins/util.js';

export default {
  name: 'VerifyEmail',
  mixins: [util],
  data: () => ({
    loading: false,
    responseStatus: null,
    errorSummary: null,
    verified: null,
    provider: null,
  }),
  mounted() {
    this.submit();
  },
  methods: {
    submit() {
      let decodedSearch = decodeURIComponent(window.location.search).replace(/&amp;/g, '&');
      console.log('Fixed Decoded search string:', decodedSearch);

      let params = new URLSearchParams(decodedSearch);

      let resource = params.get('resource');
      let equipment = params.get('equipment');
      let institution = params.get('institution');
      let patent = params.get('patent');
      let uuid = params.get('uuid');

      if (!uuid) {
        let match = decodedSearch.match(/[?&]uuid=([^&]+)/);
        uuid = match ? match[1] : null;
      }

      console.log('Extracted values:', { resource, equipment, institution, patent, uuid });

      let link = '';

      if (resource === 'true') {
        link = `/api/v1/auth/public-contact/resource/verify-email?uuid=${uuid}`;
      } else if (equipment === 'true') {
        link = `/api/v1/auth/public-contact/equipment/verify-email?uuid=${uuid}`;
      } else if (institution === 'true') {
        link = `/api/v1/auth/public-contact/institution/verify-email?uuid=${uuid}`;
      } else if (patent === 'true') {
        link = `/api/v1/auth/public-contact/patent/verify-email?uuid=${uuid}`;
      } else {
        link = `/api/v1/auth/public-contact/provider/verify-email?uuid=${uuid}`;
      }

      console.log('Final generated link:', link);

      this.axios
        .post(link)
        .then(body => {
          if (body.data.message) {
            this.provider = true;
          } else {
            this.verified = true;
          }
        })
        .catch(error => {
          if (error.request && error.response.status === 400) {
            this.errorSummary = this.$i18n.t(error.response.headers.message);
          }
        });
    },
  },
};
</script>
